import { createStore, applyMiddleware, compose } from "redux";
import { routerMiddleware } from "react-router-redux";
import thunk from "redux-thunk";
import { createBrowserHistory } from "history";

//import logger from "redux-logger";
import mixpanel from "mixpanel-browser";
import ReactGA from "react-ga";
import rootReducer from "./reducers";

export const history = createBrowserHistory();

const initialState = {};
const enhancers = [];

// const middleware = [thunk, routerMiddleware(history), logger];

const middleware = [thunk, routerMiddleware(history)];


if (process.env.NODE_ENV === "production") {
  mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
  ReactGA.initialize(process.env.REACT_APP_GA_ID);
  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.devToolsExtension;
  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

export default createStore(rootReducer, initialState, composedEnhancers);



// WEBPACK FOOTER //
// ./src/store.js